import React from 'react';

import i18n from 'i18n-react';
import PropTypes from 'prop-types';

import { Background, LoginForm, LanguageSelect, StoreButtons } from 'C4';

import Logo from 'assets/images/logo/logo.png';

const LoginView = props => (
  <div className="loginView">
    <div className="loginView__bg">
      <Background type="image"/>
      <div className="loginView__bg--content">
        <img src="https://front.travpromobile.com/logos/logo_white.png" alt="Company Logo" />
        <h3>{i18n.translate('loginScreen.title')}</h3>
      </div>
    </div>
    <div className="loginView__content">
      <img src={Logo} className="loginView__content--logo" alt="Logo" />
      <LoginForm path={props.match.path} />
    </div>
    <style>{'\
    #openWidget { display: block; bottom: 4rem; } '}
    </style>
    {/* {props.showLanguageDropdown && <LanguageSelect />} */}
  </div>
);

export default LoginView;

LoginView.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }),
  showLanguageDropdown: PropTypes.bool,
};

LoginView.defaultProps = {
  match: {
    path: '/login',
  },
  showLanguageDropdown: true,
};
